import { forwardRef } from "react";
import { FormControl, FormErrorMessage } from "@chakra-ui/react";
import { getMonthsShortNames, getObjValueFromPath, getWeekDaysShortNames } from "utils";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import * as React from "react";
import { useTranslation } from "react-i18next";
import EsgFormLabel from "./EsgFormLabel";

function FormDatepicker(
  {
    field,
    children,
    label,
    name,
    id = name,
    errors,
    controlProps,
    maxInlineSize,
    placeholder,
    usePortal = true,
    ...rest
  },
  ref
) {
  const { t } = useTranslation("translation");
  const error = getObjValueFromPath(name, errors);

  return (
    <FormControl
      isInvalid={error}
      maxInlineSize={maxInlineSize ? maxInlineSize : { base: "full", lg: "xs" }}
      minInlineSize="0"
      {...controlProps}
    >
      {label && (
        <EsgFormLabel
          htmlFor={id}
        >
          {label}
        </EsgFormLabel>
      )}
      <SingleDatepicker
        ref={ref}
        name={name}
        onDateChange={(date) => field.onChange(date)}
        usePortal={usePortal}
        configs={{
          dateFormat: "d MMM yyyy",
          monthNames: getMonthsShortNames(t),
          dayNames: getWeekDaysShortNames(t)
        }}
        propsConfigs={{
          dayOfMonthBtnProps: {
            defaultBtnProps: {
              _hover: {
                background: "green.500"
              }
            },
            isInRangeBtnProps: {
              background: "green.500",
              color: "white"
            },
            selectedBtnProps: {
              background: "green.500",
              color: "white"
            }
          },
          inputProps: {
            size: "md",
            id: name,
            borderRadius: "none",
            marginBlockStart: 1,
            placeholder: placeholder
          }
        }}
        {...rest}
      />
      {error && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
}

export default forwardRef(FormDatepicker);
